query enumSelect($name: String!, $where: EnumItemDTOFilterInput) {
    data: enums2(
        typeName: $name
        where: $where
    ) {
        value
        label
    }
}